// extracted by mini-css-extract-plugin
module.exports = {"root":"cart-button_root__fqIBY","quantity":"cart-button_quantity__29UmY"};